import { compose } from 'recompose'
import React, { useState, useEffect } from 'react'
import { connect as connectRedux } from 'react-redux'
import { fromJS, Map } from 'immutable'
import { getBoundActions } from '../../actions/index'
import { setSessionStorage, SESSION_STORAGE_SKIP_PRE_ROLL } from '../../services/local-preferences/index'
import {
  PRE_ROLL_IMPRESSION_GA4_EVENT,
  PRE_ROLL_SKIPPED_GA4_EVENT,
  PRE_ROLL_COMPLETED_GA4_EVENT,
} from '../../services/event-tracking/index'
import DropInVideoPlayer, { DEFAULT_CONTROLS } from '../DropInVideoPlayer/index'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'
import NextIcon from '../Icon/icons/Next/index'

function VideoPreRoll (props) {
  const {
    auth,
    mediaId,
    staticText,
    onPreRollComplete,
    onPreRollPlay,
    preRollPoC,
    setEventDefault,
    setFeatureTrackingDataPersistent,
  } = props

  const maxSkipSeconds = 3

  const [skipSeconds, setSkipSeconds] = useState(maxSkipSeconds)
  const prevMediaId = preRollPoC.get('mediaId', mediaId)
  const preRollCount = preRollPoC.get('count', 0)

  const handlePreRollComplete = () => {
    const newCountValue = mediaId === prevMediaId ? Number(preRollCount) + 1 : 1

    setFeatureTrackingDataPersistent({
      data: fromJS({
        preRollPoC: {
          mediaId,
          count: newCountValue,
        },
      }),
      auth,
    })

    setSessionStorage(SESSION_STORAGE_SKIP_PRE_ROLL, true)

    if (onPreRollComplete) {
      onPreRollComplete()
    }
  }

  const handleVideoError = () => {
    setSessionStorage(SESSION_STORAGE_SKIP_PRE_ROLL, true)
    if (onPreRollComplete) {
      onPreRollComplete()
    }
  }

  const handleSkipClick = () => {
    setEventDefault(PRE_ROLL_SKIPPED_GA4_EVENT.mergeDeep({ mediaId }))
    handlePreRollComplete()
  }

  const handleVideoPlay = () => {
    if (onPreRollPlay) {
      onPreRollPlay()
    }
  }

  const handleVideoEnd = () => {
    setEventDefault(PRE_ROLL_COMPLETED_GA4_EVENT.mergeDeep({ mediaId }))
    handlePreRollComplete()
  }

  useEffect(() => {
    setEventDefault(PRE_ROLL_IMPRESSION_GA4_EVENT.mergeDeep({ mediaId }))

    const interval = setInterval(() => {
      setSkipSeconds((prevValue) => {
        return prevValue > 0 ? prevValue - 1 : 0
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="video-pre-roll">
      <div className="video-pre-roll__container">
        <DropInVideoPlayer
          volume
          autoplay
          mediaId={mediaId}
          playsinline
          disableEndState
          enableMediaCenter
          controls={{ type: DEFAULT_CONTROLS }}
          handleVideoEnd={handleVideoEnd}
          handleVideoError={handleVideoError}
          handleVideoPlay={handleVideoPlay}
          mediaWasFetched={false}
        />
        <div className="video-pre-roll__overlay">
          <div className="video-pre-roll__message">
            <span className="video-pre-roll__message-bar" />
            {staticText.getIn(['data', 'message'])}
          </div>
          <div className="video-pre-roll__skip">
            {skipSeconds < 1
              && <Button className="video-pre-roll__skip-button" type={BUTTON_TYPES.GHOST} onClick={handleSkipClick}>
                <NextIcon />
                <span>{staticText.getIn(['data', 'skip'])}</span>
              </Button>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default compose(
  connectRedux(
    (state) => ({
      auth: state.auth,
      staticText: state.staticText.getIn(['data', 'videoPreRoll']),
      preRollPoC: state.featureTracking.getIn(['data', 'preRollPoC'], Map()) || Map(),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setEventDefault: actions.eventTracking.setEventDefault,
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
)(VideoPreRoll)
